import { EditorController } from '@ibiz-template/runtime';
import { IRaw } from '@ibiz/model-core';

/**
 * 直接内容编辑器控制器
 *
 * @export
 * @class RawEditorController
 * @extends {EditorController}
 */
export class RawEditorController extends EditorController<IRaw> {}
